export default "__VITE_ASSET__B7AvGury__"